import { billOfMaterialsTemplateBindingIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";
import {
  BomTemplatePreviewConflict,
  BomTemplatePreviewRow,
} from "./bom-template-types";

export const previewBomTemplateBinding = {
  name: "previewBomTemplateBinding" as const,
  input: z.object({ bindingId: billOfMaterialsTemplateBindingIdFormat.schema }),
  output: z.object({
    rows: z.array(BomTemplatePreviewRow),
    coverageProblems: z.array(z.string()),
    conflicts: z.array(BomTemplatePreviewConflict),
    summary: z.object({
      ready: z.number().int(),
      draft: z.number().int(),
      skipped: z.number().int(),
      conflict: z.number().int(),
    }),
  }),
};
